import { EnumTipoDomandaModuloDTOTipoAssociazione } from '@framework/api-client/api/inquiries/schemas/enumTipoDomandaModuloDTOTipoAssociazione.ts';
import { getFrontRichiesteIdModuli } from '@framework/api-client/api/inquiries-compile/richieste-controller/richieste-controller.ts';
import { type RouteHistory } from '@framework/ui/core/pagination/paginationUrlQuery.ts';
import { generatePath } from '@framework/ui/core/router/TypedRoute.tsx';
import { theme } from '#theme';

/**
 * Gestisce il redirect alla pagina di compilazione della richiesta.
 * - Se è configurato il redirect al primo modulo, verrà effettuato il redirect al primo modulo.
 * - Altrimenti, verrà effettuato il redirect alla pagina di compilazione della richiesta (guida alla compilazione).
 *
 * Questa versione va usata nei pulsanti di creazione di una richiesta;
 * per il redirect automatico alla compilazione della richiesta,
 * usare `SubmissionPrincipalModuleRedirector` (ovvero
 * redirect alla pagina di compilazione della richiesta /richieste/:id/modulo-principale).
 */
export async function redirectToSubmissionPage(
  submissionId: string,
  history: RouteHistory<any>,
) {
  // Se richiesto, faccio il redirect al primo modulo
  if (theme.redirectToFirstModule) {
    const allModules = await getFrontRichiesteIdModuli(submissionId);
    const principalModule = allModules.find(
      m =>
        m.domandaModulo?.tipoAssociazione ===
        EnumTipoDomandaModuloDTOTipoAssociazione.PRINCIPALE,
    );
    if (principalModule) {
      history.push(
        generatePath('/richieste/:id/moduli/:moduleId', {
          id: submissionId,
          moduleId: principalModule.id!,
        }),
      );
      return;
    }
  }

  // redirect alla pagina di compilazione
  history.push(generatePath('/richieste/:id', { id: submissionId }));
}
